<template>
  <div>
    <el-dialog
      class="labelDialog"
      :visible="isShow"
      title="模板配置"
      width="1000px"
      :before-close="handleClose"
    >
      <div v-loading="loading">
        <!-- tips -->
        <div class="card-point tipBg">
          <img
            src="@/assets/thdImg/pages/waringBule.svg"
            style="width: 16px; margin-right: 5px"
          />
          <template>
            <div class="card-connet">
              <p>创建模板后，修改模板只针对新活动生效，旧活动模板不变更。</p>
            </div>
          </template>
        </div>
        <div style="display: flex; justify-content: space-between">
          <div style="width: 70%">
            <el-form
              :model="ruleForm"
              class="backgroundForm"
              ref="ruleForm"
              :label-width="activityType == 8 ? '140px' : '82px'"
            >
              <el-form-item label="模板名称:" required>
                <el-input
                  v-model="ruleForm.templateName"
                  maxlength="15"
                  show-word-limit
                  placeholder="请输入模板名称"
                  style="width: 320px"
                ></el-input>
              </el-form-item>
              <el-form-item label="模板布局:" required v-if="activityType == 8">
                <el-radio v-model="ruleForm.layout" :label="1">大转盘</el-radio>
                <el-radio v-model="ruleForm.layout" :label="0">九宫格</el-radio>
              </el-form-item>
              <el-form-item
                label="按钮色号:"
                v-if="
                  activityType == 16 || activityType == 17 || activityType == 18
                "
              >
                <el-color-picker v-model="ruleForm.rgb"></el-color-picker>
              </el-form-item>
              <el-form-item label="上传图片:" required>
                <div class="downbtn" @click="handleUrl">下载模板</div>
                <div class="uploadBoxAll">
                  <div
                    v-for="(item, index) in uploadList"
                    :key="index"
                    class="uploadBox"
                  >
                    <!-- :before-upload="(file, fileList) => { beforeUpload(file, fileList, item) }" -->
                    <el-upload
                      :ref="'upload' + item.value"
                      action="#"
                      style="width: 100px"
                      list-type="picture-card"
                      :on-change="
                        (file, fileList) => {
                          handleChange(file, fileList, item.value, item);
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          handleRemove(file, fileList, item.value);
                        }
                      "
                      :http-request="httpRequest"
                    >
                      <img
                        v-if="ruleForm[item.value]"
                        :src="ruleForm[item.value]"
                        class="avatar"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="uploadBox-desc">
                      <div class="uploadBox-desc-title">{{ item.title }}</div>
                      <p>图片尺寸：{{ item.size }}</p>
                      <p>图片大小：1M以内</p>
                      <p>格式：jpg、png</p>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                label="大转盘中心坐标:"
                required
                v-if="activityType == 8 && ruleForm.layout == '1'"
              >
                Y轴<el-input
                  v-model="ruleForm.yAxis"
                  placeholder="请输入"
                  @input="ruleForm.yAxis = getNumberData($event, 0, 0, 99999)"
                  style="width: 100px; margin-left: 8px"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  ruleForm.layout == 1 ? '内容分区文字色号:' : '选中色号:'
                "
                v-if="activityType == 8"
                required
              >
                <el-color-picker v-model="ruleForm.rgb"></el-color-picker>
              </el-form-item>
              <el-form-item label="抽奖机会文案色号:" v-if="activityType == 8">
                <el-color-picker v-model="ruleForm.rgb2"></el-color-picker>
              </el-form-item>
              <el-form-item
                label="获奖名单色号:"
                v-if="activityType == 8"
                required
              >
                <el-color-picker v-model="ruleForm.rgb3"></el-color-picker>
              </el-form-item>
            </el-form>
          </div>
          <!-- 查看预览 -->
          <div class="previewBlock">
            <div class="preview">
              <!-- 首单有礼、复购有礼、下单有礼 -->
              <div
                v-if="
                  activityType == 16 || activityType == 17 || activityType == 18
                "
                class="order"
              >
                <!-- style="background-size: 100%;" -->
                <!-- :style=" ruleForm.firstPictureUrl?'background-Image:url('+ ruleForm.firstPictureUrl +')' :'background-Image:url('+ ruleForm.secondPictureUrl +')'" -->
                <div
                  class="elImg"
                  v-if="ruleForm.firstPictureUrl || ruleForm.secondPictureUrl"
                >
                  <img
                    :src="ruleForm.firstPictureUrl"
                    style="width: 100%"
                    v-if="ruleForm.firstPictureUrl"
                  />
                  <img
                    :src="ruleForm.secondPictureUrl"
                    style="width: 100%"
                    v-else-if="ruleForm.secondPictureUrl"
                  />
                  <!-- <img src="@/assets/images/template/shipname.png" style="width: 192px;margin: 147px 0 0 9px;">
										<img src="@/assets/images/template/cont1.png" style="width: 184px;margin: 49px 0 0 13px;"> -->
                  <img
                    src="@/assets/images/template/shipname.png"
                    style="
                      width: 192px;
                      position: absolute;
                      top: 147px;
                      left: 9px;
                    "
                  />
                  <img
                    src="@/assets/images/template/cont1.png"
                    style="
                      width: 184px;
                      position: absolute;
                      top: 246px;
                      left: 13px;
                    "
                  />
                  <div
                    class="orderBtn1"
                    :style="'background-color:' + ruleForm.rgb"
                    style="position: absolute; top: 155px; left: 140px"
                  >
                    进店逛逛
                  </div>
                  <div
                    class="orderBtn2"
                    :style="
                      'border-color:' + ruleForm.rgb + ';color:' + ruleForm.rgb
                    "
                    style="position: absolute; top: 172px; left: 140px"
                  >
                    关注
                  </div>
                  <div
                    class="orderBtn1"
                    :style="'background-color:' + ruleForm.rgb"
                    style="position: absolute; top: 297px; left: 36px"
                  >
                    解锁
                  </div>
                  <div
                    class="orderBtn1"
                    :style="'background-color:' + ruleForm.rgb"
                    style="position: absolute; top: 297px; left: 132px"
                  >
                    解锁
                  </div>
                  <img
                    src="@/assets/images/template/cont2.png"
                    style="
                      width: 190px;
                      position: absolute;
                      top: 425px;
                      left: 10px;
                    "
                    v-if="ruleForm.firstPictureUrl"
                  />
                </div>
                <!-- 预览图 -->
                <div class="elImg" v-else-if="ruleForm.thankPictureUrl">
                  <img :src="ruleForm.thankPictureUrl" style="width: 100%" />
                </div>
                <!-- 无背景图 -->
                <div class="elImg" v-else>
                  <img :src="nobg" class="abCenter" />
                </div>
              </div>
              <!-- 下单冲榜 -->
              <div v-if="activityType == 35" class="orderRank">
                <div
                  class="elImg"
                  v-if="ruleForm.firstPictureUrl"
                  style="background-size: 100%; border-radius: 16px 16px 0 0"
                  :style="
                    'background-Image:url(' + ruleForm.firstPictureUrl + ')'
                  "
                >
                  <!-- 背景图 -->
                  <!-- <img :src="ruleForm.firstPictureUrl" style="width: 100%;" v-if="ruleForm.firstPictureUrl"> -->
                  <!-- 排行榜区 -->
                  <img
                    :src="ruleForm.fifthPictureUrl"
                    style="
                      width: 200px;
                      position: absolute;
                      top: 195px;
                      left: 5px;
                    "
                  />
                  <!-- 底部按钮 -->
                  <div class="bottomBtn">
                    <span style="position: absolute">去下单</span>
                    <img
                      :src="ruleForm.secondPictureUrl"
                      style="width: 108px"
                    />
                  </div>
                  <img
                    src="@/assets/images/template/orderRankCont.png"
                    style="
                      width: 210px;
                      position: absolute;
                      top: 65px;
                      left: 0px;
                    "
                  />
                </div>
                <!-- 预览图 -->
                <div class="elImg" v-else-if="ruleForm.thankPictureUrl">
                  <img :src="ruleForm.thankPictureUrl" style="width: 100%" />
                </div>
                <!-- 无背景图 -->
                <div class="elImg" v-else>
                  <img :src="nobg" class="abCenter" />
                </div>
              </div>
              <!-- 幸运大抽奖 -->
              <div v-if="activityType == 8" class="turnable">
                <div
                  class="elImg"
                  v-if="ruleForm.thankPictureUrl"
                  style="background-size: 100%"
                  :style="
                    'background-Image:url(' + ruleForm.thankPictureUrl + ')'
                  "
                >
                  <!-- 背景图 -->
                  <!-- <img :src="ruleForm.thankPictureUrl" style="width: 100%;" v-if="ruleForm.firstPictureUrl"> -->
                  <!-- 大转盘 -->
                  <div v-if="ruleForm.layout == '1'">
                    <div
                      style="position: absolute; left: 33px"
                      :style="
                        'top:' +
                        (Number(ruleForm.yAxis) + Number(25)) / 2 +
                        'px'
                      "
                    >
                      <!-- 内容分区 -->
                      <img
                        :src="ruleForm.secondPictureUrl"
                        style="width: 144px"
                      />
                      <!-- 环形文字 -->
                      <div class="sector">
                        <div
                          v-for="(item, index) in sectorList"
                          :key="index"
                          :style="{
                            transform: 'rotate(' + index * 47 + 'deg)',
                            'z-index': `8 - ${index}`,
                          }"
                        >
                          <div class="sector-item">
                            <div class="sector-inner">
                              <div :style="'color:' + ruleForm.rgb">
                                {{ item.title }}
                              </div>
                              <div :style="'color:' + ruleForm.rgb">
                                {{ item.price }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- 指针 -->
                      <img
                        :src="ruleForm.firstPictureUrl"
                        style="
                          width: 68px;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                        "
                      />
                    </div>
                    <!-- 抽奖机会文案 -->
                    <div class="changesNum" :style="'color:' + ruleForm.rgb2">
                      您今天还有2次抽奖机会
                    </div>
                    <!-- 获取更多抽奖机会 -->
                    <img
                      src="@/assets/images/template/turnable-morebtn.png"
                      style="
                        width: 114px;
                        position: absolute;
                        top: 306px;
                        left: 48px;
                      "
                    />
                  </div>
                  <!-- 九宫格 -->
                  <div v-else>
                    <div class="big-box-goods">
                      <div class="bog-box-goods-act-box" id="actBorder"></div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <!-- 抽奖按钮 -->
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.firstPictureUrl +
                          ');'
                        "
                      >
                        <div class="ljcj">立即抽奖</div>
                        <div class="jh"><span>10</span>次抽奖机会</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                      <div
                        class="big-box-goods-item"
                        :style="
                          'background-image:url(' +
                          ruleForm.secondPictureUrl +
                          ');'
                        "
                      >
                        <div class="goods-icon-img"></div>
                        <div>谢谢参与</div>
                      </div>
                    </div>
                  </div>
                  <!-- 获奖名单 -->
                  <div class="turnableList">
                    <div
                      v-for="(item, index) in turnableList"
                      :key="index"
                      class="turnableList-item"
                      :style="'color:' + ruleForm.rgb3"
                    >
                      <div>{{ item.left }}</div>
                      <div>{{ item.right }}</div>
                    </div>
                  </div>
                </div>
                <!-- 预览图 -->
                <div class="elImg" v-else-if="ruleForm.fourPictureUrl">
                  <img :src="ruleForm.fourPictureUrl" style="width: 100%" />
                </div>
                <!-- 无背景图 -->
                <div class="elImg" v-else>
                  <img :src="nobg" class="abCenter" />
                </div>
              </div>
            </div>
            <div class="title">图为预览效果，以实际投效果为准</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="sureBtn">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadpic,
  getTemplate,
  saveSmartCardTemplate,
} from "@/api/paradiseAndTaskCommonController.js";
import { getSellerInfo } from "@/api/sellerController";
import { param } from "jquery";
export default {
  name: "",
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    activityType: {
      type: Number,
    },
    templateDialogType: {
      type: String,
      default: "new",
    },
    temId: {
      type: Number,
    },
    templateGroupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      nobg: require("@/assets/images/template/noBG.png"),
      sellerNick2: "",
      ruleForm: {
        smartCardType: "",
        templateName: "",
        rgb: "",
        rgb2: "",
        rgb3: "",
        firstPictureUrl: "",
        secondPictureUrl: "",
        fifthPictureUrl: "",
        thankPictureUrl: "",
        fourPictureUrl: "",
        yAxis: "",
        layout: 1,
      },
      uploadList: [
        //默认
        {
          title: "背景图",
          size: "750px*2826px",
          value: "firstPictureUrl",
        },
      ],
      // 转盘
      sectorList: [
        {
          title: "优惠券",
          price: "20元",
        },
        {
          title: "谢谢",
          price: "参与",
        },
        {
          title: "优惠券",
          price: "5元",
        },
        {
          title: "谢谢",
          price: "参与",
        },
        {
          title: "优惠券",
          price: "10元",
        },
        {
          title: "谢谢",
          price: "参与",
        },
        {
          title: "优惠券",
          price: "15元",
        },
        {
          title: "谢谢",
          price: "参与",
        },
      ],
      turnableList: [
        {
          left: "王**小",
          right: "抽中了10店铺积分",
        },
        {
          left: "王**小",
          right: "抽中了10店铺积分",
        },
        {
          left: "王**小",
          right: "抽中了10店铺积分",
        },
        {
          left: "王**小",
          right: "抽中了10店铺积分",
        },
      ],
    };
  },
  computed: {},
  created() {},
  watch: {
    activityType: {
      handler(newVal, oldVal) {
        console.log("newVal", newVal);
        // 首单有礼、复购有礼、下单有礼
        this.ruleForm.rgb = "#F97040";
        if (newVal == 16 || newVal == 17 || newVal == 18) {
          this.uploadList = [
            {
              title: "背景图",
              size: "750px*2826px",
              width: "750",
              height: "2826",
              value: "firstPictureUrl",
            },
            {
              title: "背景图（无商品区域）",
              size: "750px*1624px",
              width: "750",
              height: "1624",
              value: "secondPictureUrl",
            },
            {
              title: "预览图",
              size: "750px*2826px",
              width: "750",
              height: "2826",
              value: "thankPictureUrl",
            },
          ];
        }
        //下单冲榜
        if (newVal == 35) {
          this.uploadList = [
            {
              title: "背景图",
              size: "750px*2826px",
              width: "750",
              height: "2826",
              value: "firstPictureUrl",
            },
            {
              title: "底部按钮",
              size: "350px*78px",
              width: "350",
              height: "78",
              value: "secondPictureUrl",
            },
            {
              title: "排行榜区",
              size: "702px*810px",
              width: "702",
              height: "810",
              value: "fifthPictureUrl",
            },
            {
              title: "预览图",
              size: "750px*3308px",
              width: "750",
              height: "3220",
              value: "thankPictureUrl",
            },
          ];
        }
        //幸运大抽奖
        if (newVal == 8) {
          this.ruleForm.rgb = "#333333";
          this.ruleForm.rgb2 = "#FFFFFF";
          this.ruleForm.rgb3 = "#FFFFFF";
          this.ruleForm.layout = 1;
          this.uploadList = [
            {
              title: "背景图（有曝光商品）",
              size: "750px*2826px",
              width: "750",
              height: "2826",
              value: "thankPictureUrl",
            },
            {
              title: "背景图（无曝光商品）",
              size: "750px*1740px",
              width: "750",
              height: "1740",
              value: "fifthPictureUrl",
            },
            {
              title: "指针",
              size: "250px*282px",
              width: "250",
              height: "282",
              value: "firstPictureUrl",
            },
            {
              title: "内容分区",
              size: "514px*514px",
              width: "514",
              height: "514",
              value: "secondPictureUrl",
            },
            {
              title: "预览图",
              size: "750px*2900px",
              width: "750",
              height: "2900",
              value: "fourPictureUrl",
            },
          ];
        }
      },
      immediate: true,
      deep: true,
    },
    templateDialogType: {
      handler(newVal, oldVal) {
        console.log("activityType-newVal", newVal);
        if (newVal == "edit") {
          this.getTemplate();
        } else {
          this.ruleForm.templateName = "";
          this.ruleForm.firstPictureUrl = "";
          this.ruleForm.secondPictureUrl = "";
          this.ruleForm.thankPictureUrl = "";
          this.ruleForm.fifthPictureUrl = "";
          this.ruleForm.fourPictureUrl = "";
          if (newVal == 16 || newVal == 17 || newVal == 18) {
            this.ruleForm.rgb = "#F97040";
          } else if (newVal == 8) {
            this.ruleForm.rgb = "#333333";
            this.ruleForm.rgb2 = "#FFFFFF";
            this.ruleForm.rgb3 = "#FFFFFF";
          }
        }
      },
      immediate: true,
      deep: true,
    },
    "ruleForm.layout": {
      handler(newVal) {
        // console.log(newVal);
        if (this.activityType == 8 && newVal == 0) {
          this.uploadList = [
            {
              title: "背景图（有曝光商品）",
              size: "750px*1684px",
              width: "750",
              height: "1684",
              value: "thankPictureUrl",
            },
            {
              title: "背景图（无曝光商品）",
              size: "750px*1684px",
              width: "750",
              height: "1684",
              value: "fifthPictureUrl",
            },
            {
              title: "抽奖按钮",
              size: "160px*160px",
              width: "160",
              height: "160",
              value: "firstPictureUrl",
            },
            {
              title: "单个宫格",
              size: "160px*160px",
              width: "160",
              height: "160",
              value: "secondPictureUrl",
            },
            {
              title: "预览图",
              size: "750px*3492px",
              width: "750",
              height: "3492",
              value: "fourPictureUrl",
            },
          ];
        } else if (this.activityType == 8 && newVal == 1) {
          this.uploadList = [
            {
              title: "背景图（有曝光商品）",
              size: "750px*2826px",
              width: "750",
              height: "2826",
              value: "thankPictureUrl",
            },
            {
              title: "背景图（无曝光商品）",
              size: "750px*1740px",
              width: "750",
              height: "1740",
              value: "fifthPictureUrl",
            },
            {
              title: "指针",
              size: "250px*282px",
              width: "250",
              height: "282",
              value: "firstPictureUrl",
            },
            {
              title: "内容分区",
              size: "514px*514px",
              width: "514",
              height: "514",
              value: "secondPictureUrl",
            },
            {
              title: "预览图",
              size: "750px*2900px",
              width: "750",
              height: "2900",
              value: "fourPictureUrl",
            },
          ];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.$store.getters.loginUserInfo.sellerNick2) {
      this.sellerNick2 = this.$store.getters.loginUserInfo.sellerNick2;
    } else {
      this.getBindList();
    }
  },
  methods: {
    //模板回显
    getTemplate() {
      this.loading = true;
      getTemplate(this.temId).then((res) => {
        this.loading = false;
        this.ruleForm = res.data;
        this.ruleForm.layout = "layout" in res.data ? res.data.layout : 1;
      });
    },
    //上传图片
    async handleChange(file, fileList, value, item) {
      let refData = "upload" + value;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isLt3M = file.size < 1024 * 1024;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1M");
        // this.$refs.upload.clearFiles();
        this.$refs[refData][0].clearFiles();
      } else if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        this.$refs[refData][0].clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs[refData][0].$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.$nextTick(() => {
            // this.ruleForm[value] = res.data;
            this.$set(this.ruleForm, value, res.data);
            console.log("this.ruleForm", this.ruleForm);
          });
        });
      }
    },

    handleRemove(file, fileList, value) {
      let refData = "upload" + value;
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.imageName = "";
      // this.$refs.upload.$children[1].$el.style.display = "inline-block";
      this.$refs[refData][0].$children[1].$el.style.display = "inline-block";
      // this.ruleForm[value]= ''
      this.$set(this.ruleForm, value, "");
      console.log("this.ruleForm", this.ruleForm);
    },
    httpRequest() {},

    //上传图片前校验 不能阻止拦截 改成在change里面判断了
    async beforeUpload(file, fileList, item) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return Promise.reject();
        // return false;
      }
      let imgcheckedSize = await this.imgchecked(file, item.width, item.height);
      if (!imgcheckedSize) {
        return Promise.reject();
        // return false;
      }
      const isLt3M = file.size < 1024 * 1024;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        return Promise.reject();
        // return false;
      }
    },

    //判断尺寸方法 默认200*200  有问题不能用
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width <= width && image.height <= height;
          file.isFlag = valid;
          console.log(valid);
          if (valid) {
            console.log("Image loaded");
            resolve();
          } else {
            // _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },

    // 下载模板
    handleUrl() {
      let url = "";
      // 调查问卷发货模板
      if (this.activityType == 17) {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/首购有礼-下载模板.psd";
      } else if (this.activityType == 16) {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/下单有礼-下载模板.psd";
      } else if (this.activityType == 35) {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/下单冲榜-下载模板.psd";
      } else if (this.activityType == 18) {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/复购有礼-下载模板.psd";
      } else if (this.activityType == 8) {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/幸运大抽奖-下载模板.psd";
      } else {
        url =
          "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/CustomTemplate/幸运大抽奖-下载模板.psd";
      }
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", "导入模板.xlsx");
      document.body.appendChild(elem);
      elem.click();
    },

    // 保存
    sureBtn() {
      //todo:输入验证
      if (!this.ruleForm.templateName) {
        this.$message.warning("请输入模板名称");
        return;
      }
      if (
        this.activityType == 16 ||
        this.activityType == 17 ||
        this.activityType == 18
      ) {
        if (!this.ruleForm.firstPictureUrl) {
          this.$message.warning("请上传背景图");
          return;
        }
        if (!this.ruleForm.secondPictureUrl) {
          this.$message.warning("请上传背景图（无商品区域）");
          return;
        }
        if (!this.ruleForm.thankPictureUrl) {
          this.$message.warning("请上传预览图");
          return;
        }
        //增加传值
        this.ruleForm.fourPictureUrl = this.ruleForm.thankPictureUrl;
      }
      if (this.activityType == 35) {
        if (!this.ruleForm.firstPictureUrl) {
          this.$message.warning("请上传背景图");
          return;
        }
        if (!this.ruleForm.secondPictureUrl) {
          this.$message.warning("请上传底部按钮");
          return;
        }
        if (!this.ruleForm.fifthPictureUrl) {
          this.$message.warning("请上传排行榜区");
          return;
        }
        if (!this.ruleForm.thankPictureUrl) {
          this.$message.warning("请上传预览图");
          return;
        }
        //增加传值
        this.ruleForm.fourPictureUrl = this.ruleForm.thankPictureUrl;
      }
      if (this.activityType == 8) {
        if (!this.ruleForm.thankPictureUrl) {
          this.$message.warning("请上传背景图（有曝光商品）");
          return;
        }
        if (!this.ruleForm.fifthPictureUrl) {
          this.$message.warning("请上传背景图（无曝光商品）");
          return;
        }
        if (!this.ruleForm.firstPictureUrl) {
          this.$message.warning(
            this.ruleForm.layout == "1" ? "请上传指针" : "请上传抽奖按钮"
          );
          return;
        }
        if (!this.ruleForm.secondPictureUrl) {
          this.$message.warning(
            this.ruleForm.layout == "1" ? "请上传内容分区" : "请上传单个宫格"
          );
          return;
        }
        if (!this.ruleForm.fourPictureUrl) {
          this.$message.warning("请上传预览图");
          return;
        }
        if (!this.ruleForm.yAxis && this.ruleForm.layout == "1") {
          this.$message.warning("请设置大转盘中心坐标");
          return;
        }
      }
      let param = this.ruleForm;
      param.openSellerType = 1; //openSellerType=1代表是指定客户使用的 0是开放
      // param.allowSellerNick = this.$store.getters.loginUserInfo.sellerNick2
      param.allowSellerNick = this.sellerNick2;
      param.templateGroupIdList = [];
      param.templateGroupIdList.push(this.templateGroupId);
      param.smartCardType = this.activityType;
      param.validTimeType = 0;
      console.log("保存", param);
      saveSmartCardTemplate(param).then((res) => {
        if (res.code == 200) {
          this.$emit("onSave");
        }
      });
    },

    getBindList() {
      getSellerInfo().then((res) => {
        this.sellerNick2 = res.data.sellerNick;
      });
    },

    // 关闭
    handleClose() {
      this.$emit("onClose", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.abCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 8px 0px 8px 11px;
  display: flex;
  .card-connet {
    p {
      line-height: 14px;
      font-size: 12px;
      color: #666666;
    }
  }
}
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 108px;
}
.uploadBoxAll {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.uploadBox {
  width: 50%;
  margin-bottom: 16px;
  /deep/.el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  display: flex;
  &-desc {
    font-size: 12px;
    color: #999;
    padding: 0px 0 0px 15px;
    &-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin: 6px 0 8px 0;
    }
    > p {
      line-height: 20px;
    }
  }
  .avatar {
    width: 98px;
    height: 99px;
    border-radius: 6px;
  }
}
.downbtn {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2670fb;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.previewBlock {
  .preview {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: inset 0px 0px 8px 0px rgba(24, 0, 144, 0.22);
    border-radius: 24px 24px 24px 24px;
    overflow: hidden;
    width: 230px;
    height: 450px;
    .elImg {
      width: 210px;
      height: 430px;
      margin: 10px;
      overflow: auto;
      background: #f4f7ff;
      border-radius: 16px 16px 16px 16px;
      position: relative;
      &::-webkit-scrollbar:vertical {
        width: 0;
        background-color: transparent;
      }
      &::-webkit-scrollbar:horizontal {
        height: 8px;
      }

      &::-webkit-scrollbar {
        width: 2px;
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
        background: rgba(0, 0, 0, 0.05);
      }
      &::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
  .title {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    padding-top: 20px;
    text-align: center;
  }
}
.order {
  .orderBtn1 {
    width: 42px;
    height: 14px;
    border-radius: 7px 7px 7px 7px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 8px;
    color: #ffffff;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .orderBtn2 {
    width: 42px;
    height: 14px;
    background: #ffffff;
    border-radius: 7px 7px 7px 7px;
    border: 1px solid;
    font-weight: 400;
    font-size: 8px;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
.orderRank {
  .bottomBtn {
    align-items: center;
    justify-content: center;
    display: flex;
    position: absolute;
    bottom: 0;
    width: 210px;
    height: 28px;
    background: #ffffff;
    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
.turnable {
  .changesNum {
    position: absolute;
    top: 290px;
    left: 63px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 8px;
    line-height: 9px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .sector {
    position: absolute;
    // top: 192px;
    // left: 54px;
    top: 85%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 108px;
    height: 108px;

    transform-origin: 0% 100%;
    .sector-item {
      width: 72px;
      text-align: center;
      transform: rotate(2.5deg);
      position: absolute;
      top: 9%;
      left: -30%;
      .sector-inner {
        display: block;
        color: #f35258;
        font-size: 8px;
        font-weight: bold;
      }
    }
  }
  .turnableList {
    position: absolute;
    top: 363px;
    left: 23px;
    .turnableList-item {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 8px;
      line-height: 9px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 164px;
      margin-bottom: 6px;
    }
  }
}
.big-box-goods {
  left: 0;
  right: 0;
  z-index: 6;
  top: 115px;
  margin: auto;
  width: 72%;
  position: absolute;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  .bog-box-goods-act-box {
    width: calc(33% - 5px);
    height: 55px;
    opacity: 0.4;
    border-radius: 15px;
    position: absolute;
    background: transparent;
    top: 0px;
    left: 4px;
  }
  .big-box-goods-item {
    width: calc(33% - 5px);
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 15px;
    font-size: 12px;
    background-repeat: no-repeat;
    background-size: 100%, 100%;
    margin-bottom: 5px;
    margin-right: 5px;
    color: #000202;
    font-size: 7px;
    .goods-icon-img {
      background-image: url("http://cdn-image.yucrm.cn/images/V24/xxcy-new.png");
      background-repeat: no-repeat;
      background-size: cover;
      width: 24px;
      height: 24px;
      margin-bottom: 6px;
    }
  }
  .big-box-goods-item:nth-child(3n + 1) {
    margin-right: 0;
  }
}
</style>
